// League name translations by language
// English names are the keys (as they come from the API)
const leagueTranslations = {
  el: {
    'England Premier League': 'Αγγλία Premier League',
    'England Championship': 'Αγγλία Championship',
    'England EFL League One': 'Αγγλία EFL League One',
    'England EFL League Two': 'Αγγλία EFL League Two',
    'England National League': 'Αγγλία National League',
    'Spain La Liga': 'Ισπανία La Liga',
    'Spain Segunda Division': 'Ισπανία Segunda División',
    'Germany Bundesliga': 'Γερμανία Bundesliga',
    'Germany 2. Bundesliga': 'Γερμανία 2. Bundesliga',
    'Germany 3. Liga': 'Γερμανία 3. Liga',
    'Italy Serie A': 'Ιταλία Serie A',
    'Italy Serie B': 'Ιταλία Serie B',
    'France Ligue 1': 'Γαλλία Ligue 1',
    'France Ligue 2': 'Γαλλία Ligue 2',
    'France National': 'Γαλλία National',
    'Netherlands Eredivisie': 'Ολλανδία Eredivisie',
    'Portugal Liga NOS': 'Πορτογαλία Liga NOS',
    'Belgium Pro League': 'Βέλγιο Pro League',
    'Turkey Super Lig': 'Τουρκία Süper Lig',
    'Scotland Premiership': 'Σκωτία Premiership',
    'Scotland Championship': 'Σκωτία Championship',
    'Poland Ekstraklasa': 'Πολωνία Ekstraklasa',
    'Greece Super League': 'Ελλάδα Super League',
  },
  de: {
    'England Premier League': 'England Premier League',
    'England Championship': 'England Championship',
    'England EFL League One': 'England EFL League One',
    'England EFL League Two': 'England EFL League Two',
    'England National League': 'England National League',
    'Spain La Liga': 'Spanien La Liga',
    'Spain Segunda Division': 'Spanien Segunda División',
    'Germany Bundesliga': 'Deutschland Bundesliga',
    'Germany 2. Bundesliga': 'Deutschland 2. Bundesliga',
    'Germany 3. Liga': 'Deutschland 3. Liga',
    'Italy Serie A': 'Italien Serie A',
    'Italy Serie B': 'Italien Serie B',
    'France Ligue 1': 'Frankreich Ligue 1',
    'France Ligue 2': 'Frankreich Ligue 2',
    'France National': 'Frankreich National',
    'Netherlands Eredivisie': 'Niederlande Eredivisie',
    'Portugal Liga NOS': 'Portugal Liga NOS',
    'Belgium Pro League': 'Belgien Pro League',
    'Turkey Super Lig': 'Türkei Süper Lig',
    'Scotland Premiership': 'Schottland Premiership',
    'Scotland Championship': 'Schottland Championship',
    'Poland Ekstraklasa': 'Polen Ekstraklasa',
    'Greece Super League': 'Griechenland Super League',
  },
  es: {
    'England Premier League': 'Inglaterra Premier League',
    'England Championship': 'Inglaterra Championship',
    'England EFL League One': 'Inglaterra EFL League One',
    'England EFL League Two': 'Inglaterra EFL League Two',
    'England National League': 'Inglaterra National League',
    'Spain La Liga': 'España La Liga',
    'Spain Segunda Division': 'España Segunda División',
    'Germany Bundesliga': 'Alemania Bundesliga',
    'Germany 2. Bundesliga': 'Alemania 2. Bundesliga',
    'Germany 3. Liga': 'Alemania 3. Liga',
    'Italy Serie A': 'Italia Serie A',
    'Italy Serie B': 'Italia Serie B',
    'France Ligue 1': 'Francia Ligue 1',
    'France Ligue 2': 'Francia Ligue 2',
    'France National': 'Francia National',
    'Netherlands Eredivisie': 'Países Bajos Eredivisie',
    'Portugal Liga NOS': 'Portugal Liga NOS',
    'Belgium Pro League': 'Bélgica Pro League',
    'Turkey Super Lig': 'Turquía Süper Lig',
    'Scotland Premiership': 'Escocia Premiership',
    'Scotland Championship': 'Escocia Championship',
    'Poland Ekstraklasa': 'Polonia Ekstraklasa',
    'Greece Super League': 'Grecia Super League',
  },
  it: {
    'England Premier League': 'Inghilterra Premier League',
    'England Championship': 'Inghilterra Championship',
    'England EFL League One': 'Inghilterra EFL League One',
    'England EFL League Two': 'Inghilterra EFL League Two',
    'England National League': 'Inghilterra National League',
    'Spain La Liga': 'Spagna La Liga',
    'Spain Segunda Division': 'Spagna Segunda División',
    'Germany Bundesliga': 'Germania Bundesliga',
    'Germany 2. Bundesliga': 'Germania 2. Bundesliga',
    'Germany 3. Liga': 'Germania 3. Liga',
    'Italy Serie A': 'Italia Serie A',
    'Italy Serie B': 'Italia Serie B',
    'France Ligue 1': 'Francia Ligue 1',
    'France Ligue 2': 'Francia Ligue 2',
    'France National': 'Francia National',
    'Netherlands Eredivisie': 'Paesi Bassi Eredivisie',
    'Portugal Liga NOS': 'Portogallo Liga NOS',
    'Belgium Pro League': 'Belgio Pro League',
    'Turkey Super Lig': 'Turchia Süper Lig',
    'Scotland Premiership': 'Scozia Premiership',
    'Scotland Championship': 'Scozia Championship',
    'Poland Ekstraklasa': 'Polonia Ekstraklasa',
    'Greece Super League': 'Grecia Super League',
  },
  tr: {
    'England Premier League': 'İngiltere Premier League',
    'England Championship': 'İngiltere Championship',
    'England EFL League One': 'İngiltere EFL League One',
    'England EFL League Two': 'İngiltere EFL League Two',
    'England National League': 'İngiltere National League',
    'Spain La Liga': 'İspanya La Liga',
    'Spain Segunda Division': 'İspanya Segunda División',
    'Germany Bundesliga': 'Almanya Bundesliga',
    'Germany 2. Bundesliga': 'Almanya 2. Bundesliga',
    'Germany 3. Liga': 'Almanya 3. Liga',
    'Italy Serie A': 'İtalya Serie A',
    'Italy Serie B': 'İtalya Serie B',
    'France Ligue 1': 'Fransa Ligue 1',
    'France Ligue 2': 'Fransa Ligue 2',
    'France National': 'Fransa National',
    'Netherlands Eredivisie': 'Hollanda Eredivisie',
    'Portugal Liga NOS': 'Portekiz Liga NOS',
    'Belgium Pro League': 'Belçika Pro League',
    'Turkey Super Lig': 'Türkiye Süper Lig',
    'Scotland Premiership': 'İskoçya Premiership',
    'Scotland Championship': 'İskoçya Championship',
    'Poland Ekstraklasa': 'Polonya Ekstraklasa',
    'Greece Super League': 'Yunanistan Super League',
  },
};

export function translateLeague(league, lang) {
  if (!lang || lang === 'en') return league;
  const langMap = leagueTranslations[lang];
  if (!langMap) return league;
  return langMap[league] || league;
}
